import { CAMPAIGN_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Campaign = ObjectDefinitionRecord({
  hasAccess: (_, hasScope) => hasScope('campaign-access'),
  objectTypeId: CAMPAIGN_TYPE_ID,
  referenceObjectType: 'CAMPAIGN_PROPERTIES'
});
export default Campaign;